import img1 from '../../assets/2019/1.webp';
import img2 from '../../assets/2019/2.webp';
import img3 from '../../assets/2019/3.webp';
import img4 from '../../assets/2019/4.webp';
import img5 from '../../assets/2019/5.webp';
import img6 from '../../assets/2019/6.webp';
import img7 from '../../assets/2019/7.webp';
import img8 from '../../assets/2019/8.webp';
import img9 from '../../assets/2019/9.webp';
import img10 from '../../assets/2019/10.webp';
import img11 from '../../assets/2019/11.webp';
import img12 from '../../assets/2019/12.webp';
import img13 from '../../assets/2019/13.webp';
import img14 from '../../assets/2019/14.webp';
import img15 from '../../assets/2019/15.webp';
import img16 from '../../assets/2019/16.webp';
import img17 from '../../assets/2019/17.webp';
import img18 from '../../assets/2019/18.webp';
import img19 from '../../assets/2019/19.webp';
import img20 from '../../assets/2019/20.webp';
import img21 from '../../assets/2019/21.webp';
import img22 from '../../assets/2019/22.webp';
import img23 from '../../assets/2019/23.webp';
import img24 from '../../assets/2019/24.webp';
import img25 from '../../assets/2019/25.webp';
import img26 from '../../assets/2019/26.webp';
import img27 from '../../assets/2019/27.webp';
import img28 from '../../assets/2019/28.webp';

const img2019 = {
  img1: img1,
  img2: img2,
  img3: img3,
  img4: img4,
  img5: img5,
  img6: img6,
  img7: img7,
  img8: img8,
  img9: img9,
  img10: img10,
  img11: img11,
  img12: img12,
  img13: img13,
  img14: img14,
  img15: img15,
  img16: img16,
  img17: img17,
  img18: img18,
  img19: img19,
  img20: img20,
  img21: img21,
  img22: img22,
  img23: img23,
  img24: img24,
  img25: img25,
  img26: img26,
  img27: img27,
  img28: img28,
};

export default img2019;
